<template>
  <div class="page-container">
    <search-form ref="SearchFormRef" @search="onSearch">
      <template #formItem></template>
      <template #default>
        <el-radio-group v-model="formInfo.itemStatus" @input="onUploadStatus">
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button label="NORMAL">正常</el-radio-button>
          <el-radio-button label="BANNED">禁售</el-radio-button>
          <el-radio-button label="REVIEWING">审核中</el-radio-button>
          <el-radio-button label="UNLIST">下架</el-radio-button>
          <el-radio-button label="SELLER_DELETE">删除</el-radio-button>
          <el-radio-button label="SHOPEE_DELETE">shopee删除</el-radio-button>
        </el-radio-group>
      </template>
    </search-form>

    <el-row style="margin-top: 20px">
      <el-button type="primary" @click="handleSync()">同步</el-button>
      <el-button type="primary" @click="openBatchPrice()">批量改价</el-button>
      <el-button type="primary" @click="openBatchOnOff()">批量上下架</el-button>
    </el-row>

    <div class="summary_pagenum">
      <div>
        符合查询条件的产品共
        <span>{{ count }}</span>
        件
      </div>
    </div>
    <div class="table_header">
      <span>已选择产品{{ tableSelectData.length }}件</span>
    </div>
    <el-table
      :data="tableData"
      border
      @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        align="center"
        width="40px"></el-table-column>
      <el-table-column align="center" label="图片">
        <template slot-scope="scope">
          <el-popover
            trigger="hover"
            placement="right"
            v-if="scope.row.images && scope.row.images.length > 0"
            :open-delay="600">
            <img :src="scope.row.images[0]" class="prduct_img" alt />
            <div class="scope_img" slot="reference">
              <img :src="scope.row.images[0]" alt />
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="标题/父SKU/店铺/分类" width="300px">
        <template slot-scope="scope">
          <!-- <el-popover
            placement="bottom"
            :width="200"
            trigger="click"
            :content="scope.row.itemName">
            <div class="ellipsis" slot="reference">
              {{ scope.row.itemName }}
            </div>
          </el-popover> -->
          <el-link :href="`https://${scope.row.region}.xiapibuy.com/product/${scope.row.shopId}/${scope.row.itemId}/`" target="_blank">{{ scope.row.itemName }}</el-link>
          <div>{{ scope.row.itemSku }}</div>
          <div>{{ scope.row.shopName }}</div>
          <div>
            {{ scope.row.originalCategoryName }}
            （{{ scope.row.displayCategoryName }}）
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="primary" @click="openBatchPrice(scope.row)">
            改价
          </el-button>
          <br />
          <el-button type="primary">同步</el-button>
        </template>
      </el-table-column>
      <el-table-column align="center" label="商品状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.itemStatus === 'NORMAL'" type="success">
            正常
          </el-tag>
          <el-tag v-else-if="scope.row.itemStatus === 'BANNED'" type="warning">
            禁售
          </el-tag>
          <el-tag
            v-else-if="scope.row.itemStatus === 'REVIEWING'"
            type="warning">
            审核中
          </el-tag>
          <el-tag v-else-if="scope.row.itemStatus === 'UNLIST'" type="danger">
            下架
          </el-tag>
          <el-tag
            v-else-if="scope.row.itemStatus === 'SELLER_DELETE'"
            type="info">
            删除
          </el-tag>
          <el-tag
            v-else-if="scope.row.itemStatus === 'SHOPEE_DELETE'"
            type="info">
            shopee删除
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="变体SKU">
        <template slot-scope="scope">
          <div v-if="scope.row.hasModel">
            <div v-for="(model, idx) in scope.row.modelInfo" :key="idx">
              {{ model.model_sku }}
            </div>
          </div>
          <div v-else>{{ scope.row.itemSku }}</div>
        </template>
      </el-table-column>
      <el-table-column label="售价">
        <template slot-scope="scope">
          <div v-if="scope.row.hasModel">
            <div v-for="(model, idx) in scope.row.modelInfo" :key="idx">
              {{ model.price_info[0].original_price }}
              [{{ model.price_info[0].currency }}]
            </div>
          </div>
          <div v-else-if="scope.row.priceInfo">
            {{ scope.row.priceInfo[0].original_price }}
            [{{ scope.row.priceInfo[0].currency }}]
          </div>
        </template>
      </el-table-column>
      <el-table-column label="库存">
        <template slot-scope="scope">
          <div v-if="scope.row.hasModel">
            <div v-for="(model, idx) in scope.row.modelInfo" :key="idx">
              {{ model.stock_info_v2.seller_stock[0].stock }}
            </div>
          </div>
          <div v-else-if="scope.row.stockInfo">
            {{ scope.row.stockInfo.seller_stock[0].stock }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="发布/修改/同步时间">
        <template slot-scope="scope">
          <div>发: {{ scope.row.publishTime }}</div>
          <div>修: {{ scope.row.updateTime }}</div>
          <div>同: {{ scope.row.syncTime }}</div>
        </template>
      </el-table-column>
    </el-table>

    <el-row class="page">
      <el-pagination
        :current-page="formInfo.page"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="count"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"></el-pagination>
    </el-row>

    <el-dialog title="改价" :visible.sync="batchPriceShow">
      <div>
        <el-table :data="batchPriceList" border>
          <el-table-column align="center" label="图片">
            <template slot-scope="scope">
              <el-popover
                trigger="hover"
                placement="right"
                v-if="scope.row.images && scope.row.images.length > 0"
                :open-delay="600">
                <img :src="scope.row.images[0]" class="prduct_img" alt />
                <div class="scope_img" slot="reference">
                  <img :src="scope.row.images[0]" alt />
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="标题/店铺" width="300px">
            <template slot-scope="scope">
              <el-popover
                placement="bottom"
                :width="200"
                trigger="click"
                :content="scope.row.itemName">
                <div class="ellipsis" slot="reference">
                  {{ scope.row.itemName }}
                </div>
              </el-popover>
              <div>{{ scope.row.merchantName }}</div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            min-width="400"
            label="SKU / 币种/售价">
            <template slot-scope="scope">
              <div v-if="scope.row.hasModel">
                <div v-for="(model, idx) in scope.row.modelInfo" :key="idx">
                  <el-row
                    type="flex"
                    justify="space-between"
                    align="middle"
                    style="margin-top: 10px">
                    <span style="flex: 1; margin-right: 10px">
                      {{ model.model_sku }}
                    </span>
                    <el-input
                      v-model="model.original_price"
                      style="flex-shrink: 0; width: 200px">
                      <template slot="prepend">
                        {{ model.price_info[0].currency }}
                      </template>
                    </el-input>
                  </el-row>
                </div>
              </div>
              <div v-else>
                <el-row type="flex" justify="space-between" align="middle">
                  <span style="flex: 1; margin-right: 10px">
                    {{ scope.row.itemSku }}
                  </span>
                  <el-input
                    v-model="scope.row.original_price"
                    style="flex-shrink: 0; width: 200px">
                    <template slot="prepend">
                      {{ scope.row.priceInfo[0].currency }}
                    </template>
                  </el-input>
                </el-row>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchPriceShow = false">取消</el-button>
        <el-button type="primary" @click="handleBatchRelease">发布</el-button>
      </span>
    </el-dialog>

    <el-dialog title="上下架" :visible.sync="batchOnOffShow">
      <div>
        <div style="margin-bottom: 20px; color: red">
          仅可对正常、下架状态进行上下架操作
        </div>
        <el-table :data="batchOnOffList" border>
          <el-table-column align="center" label="图片">
            <template slot-scope="scope">
              <el-popover
                trigger="hover"
                placement="right"
                v-if="scope.row.images && scope.row.images.length > 0"
                :open-delay="600">
                <img :src="scope.row.images[0]" class="prduct_img" alt />
                <div class="scope_img" slot="reference">
                  <img :src="scope.row.images[0]" alt />
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="标题/父SKU/店铺" width="300px">
            <template slot-scope="scope">
              <el-popover
                placement="bottom"
                :width="200"
                trigger="click"
                :content="scope.row.itemName">
                <div class="ellipsis" slot="reference">
                  {{ scope.row.itemName }}
                </div>
              </el-popover>
              <div>{{ scope.row.itemSku }}</div>
              <div>{{ scope.row.merchantName }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="上下架">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.model_status"
                active-color="#13ce66"
                inactive-color="#ff4949"></el-switch>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchOnOffShow = false">取消</el-button>
        <el-button type="primary" @click="handleBatchOnOff">发布</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Baseurl, ajaxPost } from '@/api/api/api'
import searchForm from './components/searchForm.vue'

export default {
  components: {
    searchForm
  },
  data() {
    return {
      roleInfo: null,
      formInfo: {
        companyId: '',
        staffId: '',
        page: 1,
        size: 20,
        itemStatus: ''
      },
      count: 1,
      tableData: [],
      tableSelectData: [],
      cityList: [
        { label: '新加坡-店铺', value: 1 },
        { label: '台湾-店铺名', value: 2 },
        { label: '菲律宾-店铺', value: 3 },
        { label: '印度尼西亚-店铺', value: 4 }
      ],
      batchPriceShow: false,
      batchPriceList: [],
      batchOnOffShow: false,
      batchOnOffList: []
    }
  },
  created() {
    this.roleInfo = JSON.parse(localStorage.getItem('role'))
    this.formInfo.companyId = this.roleInfo.company_id
    this.formInfo.staffId = this.roleInfo.rid
  },
  mounted() {
    this.fetchTableList()
  },
  methods: {
    onSearch() {
      this.formInfo.page = 1
      this.fetchTableList()
    },
    onUploadStatus() {
      this.onSearch()
    },
    //修改size
    handleSizeChange(val) {
      this.formInfo.size = val
      this.onSearch()
    },
    //修改currentPage
    handleCurrentChange(val) {
      this.formInfo.page = val
      this.fetchTableList()
    },
    // 处理table多选
    handleSelectionChange(e) {
      this.tableSelectData = e
    },
    // 获限table数据
    async fetchTableList() {
      try {
        const url =
          Baseurl + '/shopeeShopProductController/selectShopeeOnlineProducts'
        const searchForm = this.$refs.SearchFormRef.formInfo
        const payload = {
          ...searchForm,
          ...this.formInfo
        }
        const res = await ajaxPost(url, payload)
        const { code, data } = res.data
        if (code === 200) {
          this.tableData = data.list.map((item) => {
            item.isShowAll = false

            // 处理图片列表
            if (item.images) {
              item.images = JSON.parse(item.images)
              item.images = item.images.image_url_list || []
            }
            // 处理变体
            if (item.modelInfo) {
              item.modelInfo = JSON.parse(item.modelInfo)
            }
            // 处理父体价格
            if (item.priceInfo) {
              item.priceInfo = JSON.parse(item.priceInfo)
            }
            // 处理父体库存
            if (item.stockInfo) {
              item.stockInfo = JSON.parse(item.stockInfo)
            }

            if (item.preOrder) {
              item.preOrder = JSON.parse(item.preOrder)
            }
            // 处理上下架状态
            if (item.itemStatus) {
              item.model_status = item.itemStatus === 'NORMAL'
            }

            return item
          })
          this.count = data.total
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 处理同步
    async handleSync(row) {
      try {
        if (this.tableSelectData.length <= 0 && !row) {
          this.$alert('请至少勾选一件产品！', '提示', {
            confirmButtonText: '确定'
          })
          return
        }

        await this.$confirm('此操作将同步产品产品, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        const url =
          Baseurl + '/shopeeShopProductController/batchSyncShopProduct'
        const payload = row
          ? [
              {
                shopId: row.shopId,
                itemId: row.itemId
              }
            ]
          : this.tableSelectData.map((item) => {
              return {
                shopId: item.shopId,
                itemId: item.itemId
              }
            })
        const res = await ajaxPost(url, payload)
        const { code, message } = res.data
        if (code === 200) {
          this.$message('操作成功')
          this.fetchTableList()
        } else {
          this.$message.error(message)
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 处理改价
    async openBatchPrice(row) {
      try {
        if (this.tableSelectData.length <= 0 && !row) {
          this.$alert('请至少勾选一件产品！', '提示', {
            confirmButtonText: '确定'
          })
          return
        }
        this.batchPriceShow = true
        this.batchPriceList = row ? [{ ...row }] : [...this.tableSelectData]
      } catch (error) {
        console.log(error)
      }
    },
    // 改价弹窗确认
    async handleBatchRelease() {
      try {
        const url =
          Baseurl + '/shopeeShopProductController/updateShopProductPrice'
        const payload = this.batchPriceList.map((item) => {
          return {
            shopId: item.shopId,
            item_id: item.itemId,
            price_list: item.hasModel
              ? item.modelInfo.map((model) => {
                  return {
                    model_id: model.model_id,
                    original_price: model.original_price
                  }
                })
              : [
                  {
                    model_id: null,
                    original_price: item.original_price
                  }
                ]
          }
        })
        const res = await ajaxPost(url, payload)
        const { code, message } = res.data
        if (code === 200) {
          this.$message.success('操作成功')
          this.batchPriceShow = false
          this.fetchTableList()
        } else {
          this.$message.error(message)
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 处理上下架
    async openBatchOnOff() {
      try {
        if (this.tableSelectData.length <= 0) {
          this.$alert('请至少勾选一件产品！', '提示', {
            confirmButtonText: '确定'
          })
          return
        }
        this.batchOnOffShow = true
        const arr = JSON.parse(JSON.stringify(this.tableSelectData))
        this.batchOnOffList = arr.filter((item) =>
          ['NORMAL', 'UNLIST'].includes(item.itemStatus)
        )
      } catch (error) {
        console.log(error)
      }
    },
    // 上下架弹窗确认
    async handleBatchOnOff() {
      try {
        const url = Baseurl + '/shopeeShopProductController/updateItem'
        const payload = this.batchOnOffList.map((item) => {
          return {
            shopId: item.shopId,
            itemId: item.itemId,
            itemStatus: item.model_status ? 'NORMAL' : 'UNLIST'
          }
        })
        const res = await ajaxPost(url, payload)
        const { code, message } = res.data
        if (code === 200) {
          this.$message.success('操作成功')
          this.batchOnOffShow = false
          this.fetchTableList()
        } else {
          this.$message.error(message)
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.prduct_img {
  width: 500px;
  height: 500px;
}
.scope_img {
  width: 80px;
  height: 80px;
  margin: 0 auto;
  img {
    width: 100%;
    height: 100%;
  }
}
/deep/ .badge sup {
  top: 0;
}
.zhankai_shouqi {
  width: 30px;
  height: 30px;
  border-radius: 5px;
  background: rgb(168, 168, 168);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 15px;
  cursor: pointer;
}
.page-container {
  padding-bottom: 60px;
  .summary_pagenum {
    width: 100%;
    background: #f5f5f5;
    margin: 10px 0;
    padding: 10px 20px;
    overflow: hidden;
    color: #585858;
    span {
      color: #2c8dff;
    }
  }
  .table_header {
    width: 100%;
    padding: 10px 20px;
    border: 1px solid #eee;
    border-bottom: 0px;
    overflow: hidden;
    color: #000;
  }
  .page {
    width: 100%;
    height: 50px;
    background-color: white;
    position: fixed;
    bottom: 0;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
